import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ApplicationConfig, ErrorHandler, importProvidersFrom, inject, provideAppInitializer, provideZoneChangeDetection } from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter } from '@angular/router';
import Aura from '@primeng/themes/aura';
import { ResizableModule } from 'angular-resizable-element';
import { providePrimeNG } from 'primeng/config';
import { MessageService } from 'primeng/api';
import { authInterceptorProvider } from './services/auth.interceptor';
import { GlobalErrorHandler } from './services/global-error.handler';
import { OauthService } from './services/oauth.service';

import { routes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(withInterceptorsFromDi()),
    importProvidersFrom(ResizableModule),
    provideAnimationsAsync(),
    MessageService,
    providePrimeNG({
      theme: {
        preset: Aura,
        options: {
          cssLayer: {
            name: 'primeng',
            order: 'base, primeng, theme'
          }
        }
      }
    }),
    authInterceptorProvider,
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    // Rehydrate the session from a stored token on startup (non-blocking).
    provideAppInitializer(() => {
      inject(OauthService).restoreSession();
    })
  ]
};
